import { combineReducers } from 'redux'

import createByIdReducer from '../entity/byId'
import createAllIdsReducer from '../entity/allIds'
import createIndexIdsReducer from '../entity/indexIds'
import createMetaReducer from '../entity/meta'

import {
  LoanAction,
  LoanActionType,
} from '../../features/underwriting/underwritingActions'

const adverseActions = (state = {}, action: LoanAction) => {
  switch (action.type) {
    case LoanActionType.FETCH_ADVERSE_ACTION_REASONS_SUCCESS:
      return {
        ...state,
        reasons: action.entities,
      }

    default:
      return state
  }
}

export default combineReducers({
  byId: createByIdReducer('loan'),
  allIds: createAllIdsReducer('loan'),
  indexIds: createIndexIdsReducer('loan'),
  meta: createMetaReducer('loan'),
  adverseActions,
})

// SELECTORS

export const selectLoan = (
  state: { byId: { [x: string]: any } },
  id: string | number | undefined
) => {
  if (id) {
    return state.byId[id] || {}
  } else {
    return {}
  }
}
